/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { GetLocationBaseResponse } from './GetLocationBaseResponse';
import {
    GetLocationBaseResponseFromJSON,
    GetLocationBaseResponseFromJSONTyped,
    GetLocationBaseResponseToJSON,
    GetLocationBaseResponseToJSONTyped,
} from './GetLocationBaseResponse';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
    PaymentTypeToJSONTyped,
} from './PaymentType';
import type { Gender } from './Gender';
import {
    GenderFromJSON,
    GenderFromJSONTyped,
    GenderToJSON,
    GenderToJSONTyped,
} from './Gender';
import type { GetUserContactResponse } from './GetUserContactResponse';
import {
    GetUserContactResponseFromJSON,
    GetUserContactResponseFromJSONTyped,
    GetUserContactResponseToJSON,
    GetUserContactResponseToJSONTyped,
} from './GetUserContactResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';
import type { GetStudentResponse } from './GetStudentResponse';
import {
    GetStudentResponseFromJSON,
    GetStudentResponseFromJSONTyped,
    GetStudentResponseToJSON,
    GetStudentResponseToJSONTyped,
} from './GetStudentResponse';

/**
 * 
 * @export
 * @interface GetUserResponse
 */
export interface GetUserResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetUserResponse
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    firstName: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    lastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    cellPhone: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    homePhone: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    addressLine1: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    addressLine2: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    addressLine3: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    zip: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    state: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    fullAddress: string | null;
    /**
     * 
     * @type {Gender}
     * @memberof GetUserResponse
     */
    gender: Gender;
    /**
     * 
     * @type {any}
     * @memberof GetUserResponse
     */
    dateOfBirth: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserResponse
     */
    sendPromotionalSms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserResponse
     */
    sendTransactionalSms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserResponse
     */
    sendCommunicationalSms: boolean;
    /**
     * 
     * @type {PaymentType}
     * @memberof GetUserResponse
     */
    paymentType: PaymentType;
    /**
     * 
     * @type {number}
     * @memberof GetUserResponse
     */
    payRate: number;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponse
     */
    payrollId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<GetStudentResponse>}
     * @memberof GetUserResponse
     */
    students: Array<GetStudentResponse>;
    /**
     * 
     * @type {Array<GetUserContactResponse>}
     * @memberof GetUserResponse
     */
    userContacts: Array<GetUserContactResponse>;
    /**
     * 
     * @type {Array<GetLocationBaseResponse>}
     * @memberof GetUserResponse
     */
    locations: Array<GetLocationBaseResponse>;
    /**
     * 
     * @type {Array<GetLocationBaseResponse>}
     * @memberof GetUserResponse
     */
    workLocations: Array<GetLocationBaseResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUserResponse
     */
    roles: Array<string>;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetUserResponse
     */
    totalBalance: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetUserResponse
     */
    customerId: ActorActivityRecordActorUserId | null;
}



/**
 * Check if a given object implements the GetUserResponse interface.
 */
export function instanceOfGetUserResponse(value: object): value is GetUserResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('cellPhone' in value) || value['cellPhone'] === undefined) return false;
    if (!('homePhone' in value) || value['homePhone'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('addressLine2' in value) || value['addressLine2'] === undefined) return false;
    if (!('addressLine3' in value) || value['addressLine3'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('fullAddress' in value) || value['fullAddress'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('dateOfBirth' in value) || value['dateOfBirth'] === undefined) return false;
    if (!('sendPromotionalSms' in value) || value['sendPromotionalSms'] === undefined) return false;
    if (!('sendTransactionalSms' in value) || value['sendTransactionalSms'] === undefined) return false;
    if (!('sendCommunicationalSms' in value) || value['sendCommunicationalSms'] === undefined) return false;
    if (!('paymentType' in value) || value['paymentType'] === undefined) return false;
    if (!('payRate' in value) || value['payRate'] === undefined) return false;
    if (!('payrollId' in value) || value['payrollId'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('students' in value) || value['students'] === undefined) return false;
    if (!('userContacts' in value) || value['userContacts'] === undefined) return false;
    if (!('locations' in value) || value['locations'] === undefined) return false;
    if (!('workLocations' in value) || value['workLocations'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('totalBalance' in value) || value['totalBalance'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    return true;
}

export function GetUserResponseFromJSON(json: any): GetUserResponse {
    return GetUserResponseFromJSONTyped(json, false);
}

export function GetUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'cellPhone': json['cellPhone'],
        'homePhone': json['homePhone'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'],
        'addressLine3': json['addressLine3'],
        'zip': json['zip'],
        'city': json['city'],
        'state': json['state'],
        'fullAddress': json['fullAddress'],
        'gender': GenderFromJSON(json['gender']),
        'dateOfBirth': json['dateOfBirth'],
        'sendPromotionalSms': json['sendPromotionalSms'],
        'sendTransactionalSms': json['sendTransactionalSms'],
        'sendCommunicationalSms': json['sendCommunicationalSms'],
        'paymentType': PaymentTypeFromJSON(json['paymentType']),
        'payRate': json['payRate'],
        'payrollId': json['payrollId'],
        'isActive': json['isActive'],
        'students': ((json['students'] as Array<any>).map(GetStudentResponseFromJSON)),
        'userContacts': ((json['userContacts'] as Array<any>).map(GetUserContactResponseFromJSON)),
        'locations': ((json['locations'] as Array<any>).map(GetLocationBaseResponseFromJSON)),
        'workLocations': ((json['workLocations'] as Array<any>).map(GetLocationBaseResponseFromJSON)),
        'roles': json['roles'],
        'totalBalance': BalanceUnitStatementEntryDebitFromJSON(json['totalBalance']),
        'customerId': ActorActivityRecordActorUserIdFromJSON(json['customerId']),
    };
}

export function GetUserResponseToJSON(json: any): GetUserResponse {
    return GetUserResponseToJSONTyped(json, false);
}

export function GetUserResponseToJSONTyped(value?: GetUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'cellPhone': value['cellPhone'],
        'homePhone': value['homePhone'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
        'zip': value['zip'],
        'city': value['city'],
        'state': value['state'],
        'fullAddress': value['fullAddress'],
        'gender': GenderToJSON(value['gender']),
        'dateOfBirth': value['dateOfBirth'],
        'sendPromotionalSms': value['sendPromotionalSms'],
        'sendTransactionalSms': value['sendTransactionalSms'],
        'sendCommunicationalSms': value['sendCommunicationalSms'],
        'paymentType': PaymentTypeToJSON(value['paymentType']),
        'payRate': value['payRate'],
        'payrollId': value['payrollId'],
        'isActive': value['isActive'],
        'students': ((value['students'] as Array<any>).map(GetStudentResponseToJSON)),
        'userContacts': ((value['userContacts'] as Array<any>).map(GetUserContactResponseToJSON)),
        'locations': ((value['locations'] as Array<any>).map(GetLocationBaseResponseToJSON)),
        'workLocations': ((value['workLocations'] as Array<any>).map(GetLocationBaseResponseToJSON)),
        'roles': value['roles'],
        'totalBalance': BalanceUnitStatementEntryDebitToJSON(value['totalBalance']),
        'customerId': ActorActivityRecordActorUserIdToJSON(value['customerId']),
    };
}

